import React, { useState } from 'react';
import LandloardsFAQData from './LandloardsFAQData';
import FaqRight from '../../FaqRight';

const LandLordFAQ = () => {
    const [activeIndex, setActiveIndex] = useState(1); // 1 based on id

    return (
        <section style={{ backgroundColor: '#f9fcfb', padding: '80px 0' }}>
            <div className="auto-container">
                <div className="sec-title centred" style={{ marginBottom: '50px' }}>
                    <h5 style={{ color: '#25b579', fontWeight: '700', fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '15px' }}>Landlord FAQ's</h5>
                    <h2 style={{ color: '#0a3d62', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: '300' }}>
                        Frequently Asked <strong style={{ fontWeight: '700' }}>Questions.</strong>
                    </h2>
                </div>

                <div className="row clearfix">
                    <div className="col-lg-8 col-md-12 col-sm-12 content-column">
                        <div style={{ paddingRight: '20px' }}>
                            {LandloardsFAQData.map((faq) => (
                                <div key={faq.id} style={{ 
                                    marginBottom: '20px', 
                                    backgroundColor: '#ffffff',
                                    borderRadius: '8px',
                                    padding: '5px 25px',
                                    boxShadow: activeIndex === faq.id ? '0 15px 30px rgba(0,0,0,0.06)' : '0 5px 15px rgba(0,0,0,0.03)',
                                    border: '1px solid rgba(0,0,0,0.03)',
                                    transition: 'all 0.4s ease'
                                }}>
                                    <button 
                                        onClick={() => setActiveIndex(activeIndex === faq.id ? null : faq.id)}
                                        style={{ 
                                            width: '100%', 
                                            background: 'none', 
                                            border: 'none', 
                                            display: 'flex', 
                                            justifyContent: 'space-between', 
                                            alignItems: 'center', 
                                            padding: '20px 0', 
                                            cursor: 'pointer',
                                            textAlign: 'left'
                                        }}
                                    >
                                        <h4 style={{ 
                                            color: activeIndex === faq.id ? '#25b579' : '#0a3d62', 
                                            fontSize: '1.2rem', 
                                            fontWeight: '600', 
                                            margin: 0, 
                                            transition: 'color 0.3s' 
                                        }}>
                                            {faq.queation}
                                        </h4>
                                        <div style={{
                                            width: '30px', 
                                            height: '30px', 
                                            borderRadius: '50%', 
                                            backgroundColor: activeIndex === faq.id ? '#25b579' : '#f0f5f3',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            transition: 'all 0.3s',
                                            flexShrink: 0,
                                            marginLeft: '15px'
                                        }}>
                                            <i className={`fas fa-${activeIndex === faq.id ? 'minus' : 'plus'}`} style={{ color: activeIndex === faq.id ? '#fff' : '#0a3d62', fontSize: '0.8rem' }}></i>
                                        </div>
                                    </button>
                                    <div style={{ 
                                        maxHeight: activeIndex === faq.id ? '300px' : '0', 
                                        overflow: 'hidden', 
                                        transition: 'max-height 0.4s cubic-bezier(0, 1, 0, 1)',
                                        opacity: activeIndex === faq.id ? 1 : 0
                                    }}>
                                        <p style={{ color: '#666666', lineHeight: '1.7', fontSize: '1.05rem', margin: '0 0 25px 0', paddingLeft: '20px', borderLeft: '2px solid rgba(37,181,121,0.2)' }}>
                                            {faq.answer}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-12 col-sm-12 sidebar-side">
                        <FaqRight />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LandLordFAQ;
